import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor(seconds % 3600 / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="relative z-10 flex flex-col items-center" data-id="element-34" data-mp="3h0z2wwv6xgxl">
      <div className="animate-pulse-alert flex h-16 w-16 items-center justify-center rounded-xl border border-alert/50 bg-white font-display text-3xl font-black tabular-nums text-plum sm:h-20 sm:w-20 sm:text-4xl" style={{
      fontFamily: "Montserrat, sans-serif"
    }} data-id="element-35" data-mp="3h2a913c3z0rv">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-plum/50" data-id="element-36" data-mp="10ailbyoqkb57">
        {label}
      </span>
    </div>;
}
type Props = {
  spotsTaken?: number;
};
export function Countdown({
  spotsTaken = 93
}: Props) {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 7);
  return <section aria-label="Countdown" className="relative w-full overflow-x-hidden bg-transparent" data-id="element-37" data-mp="17qzw49yauiuf">
      <div className="mx-auto max-w-3xl px-5 py-8 text-center" data-id="element-38" data-mp="12rwpil2o84kc">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-alert" data-id="element-39" data-mp="12sese0ju9h18">
          🔥 Begrenzte Zeit — endet in:
        </p>

        <div className="relative mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-40" data-mp="a37muhlyvr6h">
          <div className="animate-glow-alert pointer-events-none absolute inset-y-[-25%] left-1/2 w-[min(16rem,80%)] -translate-x-1/2 rounded-full bg-alert/30 blur-2xl" aria-hidden="true" data-id="element-41" data-mp="a5kc7fu213tk" />
          <Unit value={hh} label="Stunden" data-id="element-42" data-mp="1zhw0sna7hh6m" />
          <span className="font-display text-3xl font-black text-plum/25" data-id="element-43" data-mp="1zgkvuk50y3dx">:</span>
          <Unit value={mm} label="Min" data-id="element-44" data-mp="1vfivfzzdflad" />
          <span className="font-display text-3xl font-black text-plum/25" data-id="element-45" data-mp="1vin87lqwjpcn">:</span>
          <Unit value={ss} label="Sek" data-id="element-46" data-mp="s5erp40cccxt" />
        </div>

        <p className="mt-6 text-sm font-semibold text-plum/70" data-id="element-47" data-mp="x482ups5nrut">
          ⚠️ Dann ist es 38€. Dieser Preis kommt nicht zurück.
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-48" data-mp="124cfg4py02fr">
          <p className="mb-2 text-left text-xs font-semibold text-plum/60" data-id="element-49" data-mp="16563cy3dxh8n">
            🎟️ Plätze zum Startpreis von 19€
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-lilac" data-id="element-50" data-mp="9ggfmr52tuer">
            <div className="h-full rounded-full bg-alert" style={{
            width: `${spotsTaken}%`
          }} data-id="element-51" data-mp="edgqdfcvflc7" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-alert" data-id="element-52" data-mp="iesfljru24jv">
            Nur noch 7 Plätze zu diesem Preis
          </p>
        </div>
      </div>
    </section>;
}